export enum ChangeLogSource {
    STUDENT_DETAILS = 'student-details',
    STUDENT_PROGRAMS = 'student-programs',
    PASSPORT = 'passport',
    VISA = 'visa',
    PERMIT = 'permit',
};

export interface IGetChangeLogParams {
    source: ChangeLogSource;
    source_id: number;
}

export interface ILog {
    name: string;
    new_value: string;
    old_value: string;
}

export interface EtyChangeLog {
    id: number;
    title: string;
    description: string;
    source_id: number;
    source: ChangeLogSource;
    created_at: string;
    log: ILog[];
}